import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col } from "reactstrap";
import "../../../assets/css/custom.css";
import BoitiersId1 from "./boitiersId1.js";
import ShowBoitierHeader from "./showBoitierHeader.js";
import AlertList from "./alertList.js";
import AlertMailSetup from "./AlertMailSetup";
import { getUserRoleId } from "../Config/apiConfig.js";
import { API_URL, getApiConfig } from "../Config/apiConfig.js";
import axios from "axios";

export default function ShowBoitier() {
  const role = getUserRoleId();
  const params = useParams();
  const [boitierData, setBoitierData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const nav = useNavigate();
useEffect(() => {
  const checkBoitier = async () => {
    setLoading(true);
    setError(null);
    try {
      const id = parseInt(params.id, 10);

      if (role === 1) {
        // Admin : accès à tous les boîtiers
        const data = await fetchBoitier(id);
        setBoitierData(data);
      } else {
        // Récupère la liste des boîtiers accessibles (clients)
        const listRes = await axios.get(API_URL + "showBoitierList", getApiConfig());
        const clientBoitierIds = listRes.data?.map(b => b.id) || [];

        // Récupère la liste des boîtiers perso de l'utilisateur
        const userId = localStorage.getItem("user_params_id");
        const userRes = await axios.get(
          API_URL + `getBoitierBelongToUser/${userId}`,
          getApiConfig()
        );
        const userBoitierIds = userRes.data?.map(b => b.id) || [];

        // Fusionne les deux listes d'IDs
        const allBoitierIds = [...new Set([...clientBoitierIds, ...userBoitierIds])];

        if (!allBoitierIds.includes(id)) {
          nav(`/boitier`);
          throw new Error("Accès interdit à ce boîtier");
        }

        // Si l'ID est autorisé, fetch les infos du boîtier
        const data = await fetchBoitier(id);
        setBoitierData(data);
      }
    } catch (err) {
      setError(err.message || "Boîtier introuvable");
      setBoitierData(null);
    } finally {
      setLoading(false);
    }
  };
  checkBoitier();
}, [params.id, role]);

  const fetchBoitier = async (id) => {
    try {
      const res = await axios.get(API_URL + `showBoitier/${id}`, getApiConfig());
      if (res.data && res.data?.id) {
        return res.data.data;
      } else {
        throw new Error("Boîtier introuvable");
      }
    } catch (error) {
      throw new Error("Boîtier introuvable");
    }
  };

  return (
    <div className="main-box">
      <div className="content-wrapper-custom">
        {loading ? (
          <div>Chargement...</div>
        ) : error ? (
          <div className="error-message">{error}</div>
        ) : (
          <>
            <ShowBoitierHeader />
            <Col lg="12">
              <BoitiersId1 data={boitierData} />
            </Col>
            <Col lg="12">{role === 1 ? <AlertList /> : null}</Col>
          </>
        )}
      </div>
    </div>
  );
}